package ru.villawonka.app.platform.telegram.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * This object represents a chat.
 * @property id Unique identifier for this chat.
 * This number may have more than 32 significant bits
 * and some programming languages may have difficulty/silent defects
 * in interpreting it. But it has at most 52 significant bits,
 * so a signed 64-bit integer or double-precision float type are safe
 * for storing this identifier.
 * @property type Type of chat, can be either “group”, “supergroup” or “channel”
 * @property title Title of the chat
 * @property username Username of the chat
 * @property photoUrl URL of the chat’s photo.
 * The photo can be in .jpeg or .svg formats.
 * Only returned for Mini Apps launched from the attachment menu.
 */
@Serializable
data class WebAppChat(
    @SerialName("id")
    val id: Long,
    @SerialName("type")
    val type: String,
    @SerialName("title")
    val title: String,
    @SerialName("username")
    val username: String? = null,
    @SerialName("photo_url")
    val photoUrl: String?
)